import React from "react";
import {ContactSalesContent} from "../../../components/apps/public/contact-sales/ContactSalesContent";

export const ContactSalesPage = () => <ContactSalesContent/>
